import React, { useState, useEffect } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import MarksCoreComponent from './MarksCoreComponent'
import PropTypes from 'prop-types'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

function PdfSlideComponent(props) {
  const { mcData, timerEnd, onValueChange } = props
  const { ControlID, Url } = mcData
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  useEffect(() => {
    if (timerEnd) {
      onValueChange(ControlID, '', 0, 0, '', true)
    }
  }, [timerEnd])

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  function goToPrevPage() {
    setPageNumber((pageNumber) =>
      pageNumber > 1 ? pageNumber - 1 : pageNumber
    )
  }

  function goToNextPage() {
    setPageNumber((pageNumber) =>
      pageNumber < numPages ? pageNumber + 1 : pageNumber
    )
  }

  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        height: '100%',
        backgroundColor: 'lightblue',
        justifyContent: 'center',
        borderRadius: '10px',
        overflow: 'auto'
      }}
    >
      <div
        style={{
          flex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div
          style={{ width: '100%', height: '100%', zIndex: 0 }}
          className={'pdfDiv'}
        >
          <div
            className='PDFpages'
            style={{ zIndex: 99, display: 'flex', justifyContent: 'flex-end' }}
          >
            <span
              className={'PDFnumPages'}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {pageNumber} of {numPages} pages
            </span>
            <button
              className={'PDFback'}
              onClick={() => {
                if (pageNumber !== 1) {
                  goToPrevPage()
                }
              }}
            >
              <ArrowLeftIcon />
            </button>

            <button
              className={'PDFnext'}
              onClick={() => {
                if (pageNumber !== numPages) {
                  goToNextPage()
                }
              }}
            >
              <ArrowRightIcon />
            </button>
          </div>
          {/* <embed
            src={Url}
            type='application/pdf'
            frameBorder='0'
            scrolling='auto'
            height='100%'
            width='100%'
          ></embed> */}
          <Document
            className={'react-pdf__Document'}
            style={{ width: '100%', height: '90%' }}
            file={Url}
            loading={<div>Please wait!</div>}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <div className='dropableRichZone'>
              <Page className='pdfPage' pageNumber={pageNumber}>
                {mcData.Mark &&
                  mcData.Mark.length > 0 &&
                  mcData.Mark.map((mark, markIndex) => {
                    if (mark.PageNumber === pageNumber.toString()) {
                      return (
                        <MarksCoreComponent
                          markerData={mark}
                          x={mark.X}
                          y={mark.Y}
                        />
                      )
                    }
                  })}
              </Page>
            </div>
          </Document>
        </div>
      </div>
    </div>
  )
}

PdfSlideComponent.propTypes = {
  mcData: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  timerEnd: PropTypes.bool
}

export default PdfSlideComponent
